import * as THREE from 'three';

const INITIAL_POSITION = new THREE.Vector3(0, 2, 6);

/**
 * Creates a perspective camera sized to the given viewport dimensions.
 * Focal length is set to 70 mm (Three.js default film gauge: 35 mm width)
 * giving a ~28° vertical FOV — a natural telephoto look with low distortion.
 */
export function createCamera(
  width: number,
  height: number
): THREE.PerspectiveCamera {
  const camera = new THREE.PerspectiveCamera(
    45, // placeholder — immediately overridden by setFocalLength below
    width / height,
    0.1,
    100
  );
  camera.setFocalLength(70); // ~28° vertical FOV; telephoto, low distortion
  camera.position.copy(INITIAL_POSITION);
  return camera;
}

/**
 * Restores camera position to the default view.
 * OrbitControls.reset() must also be called to sync the controls target.
 */
export function resetCameraPosition(camera: THREE.PerspectiveCamera): void {
  camera.position.copy(INITIAL_POSITION);
}
